import React from "react";

export default function OBReport({ data, fpsId, month, year, distName, officeName }) {
  if (!data || !data.data || data.data.length === 0) {
    return (
      <div className="text-center py-4">
        <h3 className="text-lg font-semibold">No OB Details Found</h3>
      </div>
    );
  }

  return (
    <div className="p-4 max-w-4xl mx-auto">
      <h3 className="text-center text-xl font-semibold mb-4">{data.message}</h3>
      <table className="min-w-full border-collapse bg-white shadow-md rounded-lg" id="Report">
        <thead>
          <tr className="tableheader">
            <th colSpan="4" className="p-3 text-center text-lg font-semibold">
              OB Details for District: {distName} / Taluk: {officeName} / FPS: {fpsId} /{" "}
              {new Date(year, month - 1).toLocaleString("default", { month: "long" })} {year}
            </th>
          </tr>
          <tr className="tableheader">
            <th className="p-2">Sl.No</th>
            <th className="p-2">Commodity</th>
            <th className="p-2">Scheme</th>
            <th className="p-2">Entered OB (in Kgs)</th>
          </tr>
        </thead>
        <tbody>
          {data.data.map((item, index) => (
            <tr key={index} className="border-b hover:bg-gray-50">
              <td className="p-2 text-center">{index + 1}</td>
              <td className="p-2">{item.comm_short_name}</td>
              <td className="p-2">{item.scheme_short_name}</td>
              <td className="p-2 text-right bg-yellow-100">
                {Number(item.ob).toFixed(3)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}